import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Agreements`;

class AgreementService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getAgreementsTransactionsList(
    body: any
  ): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "transactions" });
    } catch (e) {
      throw e;
    }
  }

  public getAgreementsMappingList(id: number, planId?: number): Promise<IApiResponse | void> {
    try {
      const resource = planId
        ? { name: `agreementMapList/${planId}` }
        : { name: "agreementMapList" };
      return super.getById(id, resource);
    } catch (e) {
      throw e;
    }
  }

  public addAgreementToPlan(
    agreementID: number,
    planActID: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${agreementID}/planActivities/${planActID}`;
      return super.create(undefined);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public removePlanActivitiesById(
    id: number,
    agreementID: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${agreementID}/planActivities`;
      return super.delete(id);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public removeRestructureplanById(
    id: number,
    agreementID: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${agreementID}/restructureplan`;
      return super.delete(id);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public addAgreementToRestructurePlan(
    agreementID: number,
    paymentPlanID: number,
    flowType: string
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${agreementID}/restructurePlan/${paymentPlanID}`;
      return super.create({flowType});
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public addAgreementToRestructurePlanByExistPlan(
    agreementID: number,
    planExistID: number,
    flowType: string,
    planId: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${agreementID}/restructurePlan/existPlan/${planId}/${planExistID}`;
      return super.create({flowType});
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public getAgreementsList(body: any): Promise<IApiResponse | void> {
    console.log(body);
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public getAgreement(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id);
    } catch (e) {
      throw e;
    }
  }
  public updateAgreement(
    body: any,
    id: number
  ): Promise<IApiResponse | void> {
    try {
      return super.update(body, id);
    } catch (e) {
      throw e;
    }
  }
  public createAgreementWithTransaction(payload: any): Promise<IApiResponse | void> {
    console.log(payload);
    try {
      return super.create(payload, { name: "CreatAgreementTrans" });
    } catch (e) {
      throw e;
    }
  }

  // public getAgreementSummary(id: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         return super.getById(id, { name: "summary" }, queries);
  //     } catch (e) {
  //         throw e;
  //     }
  // }

  // public getAgreementBody(body: any): Promise<IApiResponse | void> {
  //     try {
  //         return super.create(body, { name: "projectlist" });
  //     } catch (e) {
  //         throw e;
  //     }
  // }

  // public modifyLoanSources(planId: number, ProjectID: number, body: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/Projects`;
  //         return super.createById(body, ProjectID, { name: "loansources" });
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }

  // public addProjectToPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/project`;
  //         return super.update(undefined, ProjectID, undefined, queries);
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }

  // public removeProjectFromPlan(planId: number, ProjectID: number, queries: any): Promise<IApiResponse | void> {
  //     try {
  //         this.url = `${this.url}/${planId}/project`;
  //         return super.delete(ProjectID, queries);
  //     } catch (e) {
  //         throw e;
  //     } finally {
  //         this.url = url;
  //     }
  // }
}
const agreementServiceAPI = new AgreementService(url);
export default agreementServiceAPI;
